// @ts-nocheck
import React, { useState, useEffect } from 'react';

const _t = () => (window).__ENGPORTAL_THEME || null;
const _dark = { bg: "#0B1120", surface: "#111827", surfaceHover: "#1a2332", border: "#1E293B", borderLight: "#334155", text: "#E2E8F0", textMuted: "#94A3B8", textDim: "#64748B", accent: "#3B82F6", accentGlow: "rgba(59, 130, 246, 0.15)", green: "#10B981", yellow: "#F59E0B", red: "#EF4444", purple: "#8B5CF6", orange: "#F97316", cardShadow: "none", mode: "dark" };
const theme = new Proxy(_dark, { get: (fallback, prop) => { const t = _t(); return t ? t[prop] : fallback[prop]; }});

const csrfToken = () => document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';

export default function TeamWinsPage() {
  const iStyle = { width: '100%', padding: '10px 14px', background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, fontSize: 14, outline: 'none', boxSizing: 'border-box' };
  const [wins, setWins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', description: '' });
  const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState('');
  const [saving, setSaving] = useState(false);

  const loadData = async () => {
    try {
      const res = await fetch('/api/notifications/team-wins/', { credentials: 'same-origin' });
      if (res.ok) { const d = await res.json(); setWins(Array.isArray(d) ? d : d?.results || []); }
    } catch(e){}
    try {
      const pRes = await fetch('/api/programs/programs/', { credentials: 'same-origin' });
      if (pRes.ok) { const pd = await pRes.json(); setPrograms(pd.all_programs || pd.results || []); }
    } catch(e){}
    setLoading(false);
  };
  useEffect(() => { loadData(); }, []);

  const addWin = async () => {
    if (!form.title) return;
    if (!selectedProgram) return alert('Please select a program');
    setSaving(true);
    try {
      const res = await fetch('/api/notifications/team-wins/', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken() },
        body: JSON.stringify({ title: form.title, description: form.description, program: selectedProgram }),
      });
      if (res.ok) {
        setForm({ title: '', description: '' }); setShowForm(false); setSelectedProgram('');
        loadData();
      } else { alert('Error: ' + await res.text()); }
    } catch(e) { alert('Failed to post'); }
    setSaving(false);
  };

  const toggleLike = async (winId) => {
    try {
      const res = await fetch(`/api/notifications/team-wins/${winId}/like/`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'X-CSRFToken': csrfToken() },
      });
      if (res.ok) {
        const data = await res.json();
        setWins(prev => prev.map(w => w.id === winId ? { ...w, like_count: data.like_count, liked_by_me: data.liked } : w));
      }
    } catch(e) {}
  };

  const deleteWin = async (winId) => {
    if (!confirm('Delete this win?')) return;
    try {
      await fetch(`/api/notifications/team-wins/${winId}/`, {
        method: 'DELETE', credentials: 'same-origin',
        headers: { 'X-CSRFToken': csrfToken() },
      });
      setWins(prev => prev.filter(w => w.id !== winId));
    } catch(e) {}
  };

  if (loading) return <div style={{ color: theme.textDim, padding: 40, textAlign: 'center' }}>Loading...</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, height: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ color: theme.text, fontSize: 20, fontWeight: 700, margin: 0 }}>Team Wins</h2>
        <button onClick={() => setShowForm(!showForm)} style={{ padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, background: theme.green, color: '#fff', border: 'none', cursor: 'pointer' }}>🎉 Share a Win</button>
      </div>
      {showForm && (
        <div style={{ background: theme.surface, border: `1px solid ${theme.green}44`, borderRadius: 12, padding: 16 }}>
          <input value={form.title} onChange={e => setForm(p => ({...p, title: e.target.value}))} placeholder="What's the win?" style={{...iStyle, marginBottom: 10}} />
          <textarea value={form.description} onChange={e => setForm(p => ({...p, description: e.target.value}))} placeholder="Tell us more..." style={{...iStyle, height: 60, resize: 'vertical', marginBottom: 10}} />
          <select value={selectedProgram} onChange={e => setSelectedProgram(e.target.value)} style={{...iStyle, appearance: 'auto', marginBottom: 10}}>
            <option value="">Select program...</option>
            {programs.map(p => <option key={p.id} value={p.id}>{p.code} — {p.name}</option>)}
          </select>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button onClick={() => setShowForm(false)} style={{ padding: '6px 14px', borderRadius: 6, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer', fontSize: 12 }}>Cancel</button>
            <button onClick={addWin} disabled={saving} style={{ padding: '6px 14px', borderRadius: 6, background: theme.green, color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>{saving ? 'Posting...' : 'Post'}</button>
          </div>
        </div>
      )}
      <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {wins.length === 0 && <div style={{ color: theme.textDim, textAlign: 'center', padding: 40 }}>No wins shared yet. Be the first to celebrate a team achievement!</div>}
        {wins.map(w => (
          <div key={w.id} style={{ background: theme.surface, border: `1px solid ${w.pinned ? theme.yellow+'66' : theme.border}`, borderRadius: 10, padding: 16 }}>
            {w.pinned && <div style={{ color: theme.yellow, fontSize: 10, fontWeight: 700, marginBottom: 6 }}>📌 PINNED</div>}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ color: theme.text, fontSize: 16, fontWeight: 600 }}>🏆 {w.title}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ color: theme.textDim, fontSize: 11 }}>{w.created_at ? new Date(w.created_at).toLocaleDateString() : ''}</span>
                <button onClick={() => deleteWin(w.id)} style={{ background: 'none', border: 'none', color: theme.textDim, cursor: 'pointer', fontSize: 14 }} title="Delete">×</button>
              </div>
            </div>
            {w.description && <div style={{ color: theme.textMuted, fontSize: 13, marginBottom: 10, lineHeight: 1.6 }}>{w.description}</div>}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: theme.textDim, fontSize: 12 }}>Posted by {w.posted_by_name || 'Team Member'}</span>
              <button onClick={() => toggleLike(w.id)}
                style={{ background: w.liked_by_me ? theme.accent+'22' : 'none', border: `1px solid ${w.liked_by_me ? theme.accent : theme.border}`, borderRadius: 6, padding: '4px 10px', color: w.liked_by_me ? theme.accent : theme.textMuted, fontSize: 12, cursor: 'pointer' }}>
                👍 {w.like_count || 0}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
